export enum Role {
  Admin = 'Admin',
  FullAccess = 'FullAccess',
  ReadOnly = 'ReadOnly',
  NoAccess = 'NoAccess',
}

export enum Status {
  Unknown = 'Unknown',
  Removed = 'Removed',
  Pending = 'Pending',
  Active = 'Active',
}

export interface User {
  /** Trimble Identity - TID. */
  id: string;

  /** Connect user id. Not the same as TID. */
  connectId: string;

  title?: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  language?: string;
  status: Status;
  role: Role;
  roleClaims?: string[];
}
